module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth-form unsubscribe-form"
  }, [_c('div', {
    staticClass: "text-center logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.stylePathToLogo || '/static/img/logo/logo.png'
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/unsubscribe')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.successMessage !== false),
      expression: "successMessage !== false"
    }],
    staticClass: "w5-field text-center alert alert-success margin-20-0"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.successMessage)),
      expression: "localeFtc(successMessage)"
    }],
    staticStyle: {
      "margin": "0",
      "padding": "10px"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorMessage !== false),
      expression: "errorMessage !== false"
    }],
    staticClass: "w5-field text-center alert alert-danger margin-20-0"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.errorMessage)),
      expression: "localeFtc(errorMessage)"
    }],
    staticStyle: {
      "margin": "0",
      "padding": "10px"
    }
  })]), _vm._v(" "), (_vm.showQuestion === false) ? [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-left code-link"
  }, [_vm._v(_vm._s(_vm._f("ftc")('login/return_to_main_page1')) + " "), _c('a', {
    attrs: {
      "href": "/",
      "title": _vm._f("ftc")('login/return_to_main_page2')
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('login/return_to_main_page2')))])])] : [_c('div', {
    staticClass: "w5-field text-left margin-20-0"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('main/unsubscribe_question')),
      expression: "localeFtc('main/unsubscribe_question')"
    }],
    staticStyle: {
      "margin": "0",
      "padding": "10px"
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('main/unsubscribe_text')),
      expression: "localeFtc('main/unsubscribe_text')"
    }],
    staticStyle: {
      "margin": "0",
      "padding": "10px"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "line-height": "50px"
    }
  }, [_c('a', {
    staticClass: "pull-left",
    attrs: {
      "href": "/",
      "title": _vm._f("ftc")('login/return_to_main_page2')
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('login/return_to_main_page2')))]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.unsubscribeStart($event)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/unsubscribe_button')))])])])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4af92e90"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/Unsubscribe.vue
// module id = 461
// module chunks = 0